// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__c3wwf","reviewRating":"style_reviewRating__dvY5V","reviewCount":"style_reviewCount__ll9V7"};